var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnseat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.62756 12.7007L10.6409 13.714L12.6676 11.6874M8.10623 7.24671C8.03956 7.24004 7.95956 7.24004 7.88623 7.24671C7.12103 7.22073 6.39599 6.89793 5.86465 6.34668C5.33331 5.79543 5.03739 5.05901 5.03956 4.29337C5.03851 3.90493 5.11413 3.52009 5.2621 3.16093C5.41006 2.80176 5.62746 2.47533 5.90182 2.20035C6.17619 1.92537 6.50212 1.70723 6.86095 1.55846C7.21978 1.40969 7.60445 1.3332 7.9929 1.33337C9.62623 1.33337 10.9529 2.66004 10.9529 4.29337C10.9529 5.89337 9.68623 7.19337 8.10623 7.24671Z",
    stroke: "#05603A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99336 14.54C6.78003 14.54 5.57336 14.2333 4.65336 13.62C3.04003 12.54 3.04003 10.78 4.65336 9.70662C6.48669 8.47995 9.49336 8.47995 11.3267 9.70662",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnseat);
export default __webpack_public_path__ + "static/media/onseat.2eb3cce2dc82fedee4f3a5b6c85bf662.svg";
export { ForwardRef as ReactComponent };